export default "__VITE_ASSET__BZB6nnep__ 480w, __VITE_ASSET__DeJBkpVE__ 768w, __VITE_ASSET__b$enc8WJ__ 1200w";